import { useState } from "react";
import Button from "@mui/material/Button";
import { toast } from "react-toastify";
import { getAuth, signOut } from "firebase/auth";

const Sessions = () => {
  const [sessions, setSessions] = useState([
    {
      id: 1,
      device: "Chrome on Windows",
      location: "Rawalpindi, PK",
      time: "Active now",
      icon: "desktop_windows",
      current: true,
    },
    {
      id: 2,
      device: "Safari on iPhone",
      location: "Rawalpindi, PK",
      time: "2 hours ago",
      icon: "phone_iphone",
      current: false,
    },
    {
      id: 3,
      device: "Firefox on MacOS",
      location: "Lahore, PK",
      time: "Yesterday",
      icon: "laptop_mac",
      current: false,
    },
  ]);

  const handleRevoke = (id) => {
    setSessions((prev) => prev.filter((s) => s.id !== id));
    toast.success("Session revoked");
  };

  const handleRevokeAll = async () => {
    try {
      const auth = getAuth();
      await signOut(auth);
      localStorage.removeItem("user");
      localStorage.removeItem("token");
      localStorage.removeItem("role");
      window.location.href = "/login";
    } catch (err) {
      toast.error("Failed to sign out of all sessions");
    }
  };

  return (
    <div className="profile-card">
      <div className="profile-card-header">
        <div>
          <h3>Session Management</h3>
          <p>View and manage your active login sessions.</p>
        </div>
        <Button
          variant="outlined"
          color="error"
          size="small"
          startIcon={<span className="material-symbols-outlined">logout</span>}
          onClick={handleRevokeAll}
        >
          Revoke All
        </Button>
      </div>

      <div className="sessions-list">
        {sessions.map((session) => (
          <div key={session.id} className="session-item">
            <div className="session-icon">
              <span className="material-symbols-outlined">{session.icon}</span>
            </div>

            <div className="session-info">
              <p className="session-device">
                {session.device}
                {session.current && (
                  <span className="current-badge">Current</span>
                )}
              </p>
              <p className="session-meta">
                {session.location} · {session.time}
              </p>
            </div>

            {!session.current && (
              <Button
                size="small"
                variant="text"
                color="error"
                onClick={() => handleRevoke(session.id)}
              >
                Revoke
              </Button>
            )}
          </div>
        ))}

        {sessions.filter((s) => !s.current).length === 0 && (
          <p className="no-sessions">No other active sessions found.</p>
        )}
      </div>
    </div>
  );
};

export default Sessions;